import { setParentUnlock, clearParentUnlock } from "@/lib/parentUnlock";
import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem("bb_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("bb_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    // another tab logged in/out with a different account: follow it instead of showing stale (empty) pages
    const onStorage = (e) => { if (e.key === "bb_token") refresh(); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = (token, userData, parentUnlock) => {
    localStorage.setItem("bb_token", token);
    setParentUnlock(parentUnlock);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("bb_token");
    clearParentUnlock();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
